module.exports = __webpack_public_path__ + "img/handraw_localisation bleu.9174b67e.svg";